import { Link, useParams } from "react-router-dom"
import { Form, FormGroup, Input, Label, Button } from "reactstrap"
import useData from "./data"

export default function AddExpense() {
  const { group_id } = useParams()

  const {
    title,
    setTitle,
    amount,
    setAmount,
    handleSubmit,
    adding,
    done,
    setDone,
  } = useData(group_id)

  return (
    <div className="p-2 mt-2">
      <h3>Add Expense</h3>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="title">Title</Label>
          <Input
            type="text"
            id="title"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value)
              setDone(false)
            }}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="amount">Amount</Label>
          <Input
            type="number"
            id="amount"
            value={amount}
            onChange={(event) => setAmount(Number(event.target.value))}
            required
          />
        </FormGroup>
        <Button
          type="submit"
          color="primary"
          className="w-100 mt-3"
          disabled={adding}
        >
          <i className="bx bx-dollar mr-1"></i>
          Add Expense
        </Button>
      </Form>

      {done && (
        <>
          <div className="alert alert-info my-2 mt-3">
            <i className="bx bx-check-circle"></i> &nbsp;
            Expense added successfully
          </div>

          <Link to={`/expense-group/${group_id}`} className="btn btn-primary mt-1">
            <i className="bx bx-file"></i>  &nbsp;
            View Expense Group
          </Link>
        </>
      )}


    </div>
  )
}
